import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </>,
  // <React.StrictMode>
  // </React.StrictMode>,
);
